import { Plot } from "../../../../web-visualizator";

export class SignalScaleCalculator {
  constructor() {}

  static getDefaultScaleY(plot, signalsSettings) {
    let plotHeight = plot.sizeInPixels.height / (plot.canvas.ppcm / 10); // in mm
    return parseFloat(+(plotHeight / signalsSettings.defaultValueRange).toFixed(3));
  }

  static generateScalesY(plot, signalsSettings, scalesY) {
    let defaultScaleY = SignalScaleCalculator.getDefaultScaleY(plot, signalsSettings);

    let newScalesY = [];
    let defaultScaleYIndex = undefined;
    for (let i = 0; i < scalesY.length; i++) {
      if (scalesY[i] < defaultScaleY) {
        newScalesY.push(scalesY[i]);
      } else {
        if (scalesY[i] > defaultScaleY) {
          defaultScaleYIndex = i;
          newScalesY.push(defaultScaleY);
        }
        for (let j = i; j < scalesY.length; j++) {
          newScalesY.push(scalesY[j]);
        }
        break;
      }
    }
    return {
      scalesY: newScalesY,
      defaultScaleYIndex: defaultScaleYIndex
    };
  }

  static generateScales(plot) {
    let signalsSettings = Plot.findContentSettings(plot.settings, "signals", "central");
    if (signalsSettings.scaleY.hasDynamicDefaultValue) {
      let scalesYInfo = SignalScaleCalculator.generateScalesY(
        plot,
        signalsSettings,
        signalsSettings.scaleY.defaultValues[signalsSettings.scaleY.defaultIndex]
      );
      signalsSettings.scaleY.defaultIndex = scalesYInfo.defaultScaleYIndex;
      signalsSettings.scaleY.values = scalesYInfo.scalesY;
    } else {
      signalsSettings.scaleY.values = signalsSettings.scaleY.defaultValues;
    }
    signalsSettings.scaleX.values = [];
    for (let i = 0; i < signalsSettings.scaleX.defaultValues.length; i++) {
      signalsSettings.scaleX.values.push(signalsSettings.scaleX.defaultValues[i]);
    }
    signalsSettings.scaleX.currIndex = signalsSettings.scaleX.defaultIndex;
    signalsSettings.scaleY.currIndex = signalsSettings.scaleY.defaultIndex;
  }

  static updateScales(plot) {
    let signalsSettings = Plot.findContentSettings(plot.settings, "signals", "central");
    if (signalsSettings.scaleY.hasDynamicDefaultValue) {
      let isDefaultSelected = this.scaleY.index == this.webglPlot.signalsBox.settings.scaleY.defaultIndex;
      let defaultScaleYValue = SignalScaleCalculator.getDefaultScaleY(plot, signalsSettings);
      let scalesYInfo = SignalScaleCalculator.generateScalesY(defaultScaleYValue);
      if (
        this.settings.scaleY.defaultIndex != scalesYInfo.defaultScaleYIndex ||
        this.scalesY[this.settings.scaleY.defaultIndex].text != scalesYInfo.scalesY[scalesYInfo.defaultScaleYIndex].text
      ) {
        this.scalesY = [];
        for (let i = 0; i < scalesYInfo.scalesY.length; i++) {
          this.scalesY.push({
            text: scalesYInfo.scalesY[i],
            index: i
          });
        }
        this.settings.scaleY.defaultIndex = scalesYInfo.defaultScaleYIndex;
      }
      if (isDefaultSelected) {
        this.scaleY = {
          text: defaultScaleYValue,
          index: this.settings.defaultScaleYIndex
        };
      }
    }
  }
}
